import * as React from 'react';

function ProjectForCastIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={72.36}
      height={72.36}
      viewBox='0 0 72.36 72.36'
      {...props}
    >
      <g id='Group_977' data-name='Group 977' transform='translate(-1369.035 -228.178)'>
        <path
          id='Path_359'
          data-name='Path 359'
          d='M11.04,75.36H67.32a8.048,8.048,0,0,0,8.04-8.04V11.04A8.048,8.048,0,0,0,67.32,3H11.04A8.048,8.048,0,0,0,3,11.04V67.32A8.048,8.048,0,0,0,11.04,75.36Zm0-64.32H67.32l0,56.28H11.04Z'
          transform='translate(1366.035 225.178)'
          fill='#fff'
        />
        <path
          id='Path_360'
          data-name='Path 360'
          d='M33.026,21.035,16.946,13,7.1,32.673l7.2,3.594L20.54,23.785l16.08,8.04,9.841-19.678-7.2-3.594Z'
          transform='translate(1378.432 241.948)'
          fill='#fff'
        />
      </g>
    </svg>
  );
}
export default ProjectForCastIcon;
